import React, { ChangeEvent, useEffect, useState } from "react";
import { IDeptartment } from "../../../interfaces/IDepartment";
import { IDisplayState } from "../../../interfaces/IDisplayState";
import BrowserService from "../../../utilities/browserService";
import UserService from "../../../utilities/userService";
import Icon from "../../icon/icon";
import "./departmentSelect.scss";
import WbmSelect from "../../wbmSelect/wbmSelect";

export interface IDepartmentSelectProps {
  departments: IDeptartment[];
  department: string;
  displayState: IDisplayState;
  forceCloseDep?: boolean;
  onDepartmentChange: React.ChangeEventHandler<HTMLSelectElement>;
  width: number;
}

function DepartmentSelect(props: IDepartmentSelectProps) {
  const [selected, setSelected] = useState(false);

  const departments = props.departments
    ? props.departments.map((department) => {
        return {
          value: department.searchCategoryId
            ? department.searchCategoryId
            : department.name,
          label: department.name,
        };
      })
    : [];

  const matchingDepartment = departments.filter(
    (d) => d.value === props.department
  );
  const defaultValue =
    matchingDepartment.length !== 0
      ? matchingDepartment[0]
      : departments.length !== 0
      ? departments[0]
      : {};

  const forceCloseDep = () => {
    if (props.forceCloseDep) {
      setSelected(false);
    }
  };

  useEffect(() => {
    if (typeof document !== undefined) {
      document.addEventListener("closeDepartmentDropdown", forceCloseDep);
    }

    return () => {
      document.removeEventListener("closeDepartmentDropdown", forceCloseDep);
    };
  });

  return (
    <>
      {!props.displayState.hasDepartments ? (
        <></>
      ) : (
        <WbmSelect
          className="department-select"
          options={departments}
          onMenuOpen={() => {
            setSelected(true);
          }}
          onMenuClose={() => {
            setSelected(false);
          }}
          onChange={(value: { value: string }) => {
            props.onDepartmentChange({
              target: {
                value: value.value,
              },
            } as unknown as ChangeEvent<HTMLSelectElement>);
          }}
          isDisabled={!UserService.displayUserInfo()}
          value={defaultValue}
          width={props.width}
          dropdownIsOpen={selected}
          forceCloseDep={props.forceCloseDep}
          fallback={
            <div
              onClick={() => {
                setSelected(true);
              }}
              onBlur={() => {
                setSelected(false);
              }}
              className="department-select-container"
              id="Category"
            >
              <span className="select-divider"></span>
              <span className={`select-arrow ${selected ? "selected" : ""}`}>
                <Icon>keyboard_arrow_down</Icon>
              </span>
              <label htmlFor="Category" className="sr-only">
                Category
              </label>
              <select
                name="Category"
                id="Category"
                onChange={props.onDepartmentChange}
                value={props.department}
                style={{ width: props.width }}
                className={`category-select ${
                  !BrowserService.transitionsSupported() ? "no-animations" : ""
                }`}
              >
                {props.departments &&
                  props.departments.map((department) => (
                    <option
                      key={department.name}
                      value={
                        department.searchCategoryId
                          ? department.searchCategoryId
                          : department.name
                      }
                    >
                      {department.name}
                    </option>
                  ))}
              </select>
            </div>
          }
        />
      )}
    </>
  );
}

export default DepartmentSelect;
